export const FileUpload = 'atlantis-file-upload';
export const FileUploadInput = 'atlantis-file-upload-input';
